import { Avatar, Box, useColorModeValue } from "@chakra-ui/react";
import { roleStyles } from "components/Tag/UserTag/helpers";
import { UserRole } from "features/User/models";

interface ResourceTargetAvatarProps {
  name?: string;
  src?: string;
  roleName?: UserRole;
}

/**
 * Shared avatar component for resource targets (recipients, assignees, attendees)
 * Uses role-based colors for consistent visual distinction across the app.
 */
export default function ResourceTargetAvatar({ name, src, roleName }: ResourceTargetAvatarProps) {
  const colorStyles = roleStyles(roleName);
  const bgColor = useColorModeValue(
    colorStyles.light,
    colorStyles.dark,
  );

  return (
    <Box position="relative">
      <Avatar
        size="sm"
        name={name}
        src={src}
        bgColor={bgColor}
        color="gray.500"
        showBorder
        borderColor="disabledGray.DEFAULT"
        borderWidth="1px"
      />
    </Box>
  );
}
